import { CSSProperties } from 'react'

export const labelStyles: { [key: string]: CSSProperties } = {
  axisTick: {
    fontFamily: 'var(--font-plex)',
    fontSize: '13px',
    fontWeight: '300',
  },
  axisTickBold: {
    fontFamily: 'var(--font-plex)',
    fontSize: '12px',
    fontWeight: '700',
    letterSpacing: '0.2px',
  },
  annotation: {
    fontFamily: 'var(--font-plex)',
    fontSize: '12px',
    fontWeight: '300',
    letterSpacing: '0.2px',

  },
  drinksMix: {
    fontFamily: 'var(--font-plex)',
    fontSize: '12px',
    fontWeight: '300',
    letterSpacing: '0.2px',
    color: 'var(--text-color)',
  },
  annotationBold: {
    fontFamily: 'var(--font-plex)',
    fontSize: '15px',
    fontWeight: '700',
    letterSpacing: '0.2px',
  },
  userMarker: {
    fontFamily: 'var(--font-plex)',
    fontSize: '18px',
    fontWeight: '700',
    letterSpacing: '0.5px',
  },
  userText: {
    color: 'var(--orange-main)',
    fontFamily: 'var(--font-plex)',
    fontSize: '15px',
  },
  healthText: {
    color: 'var(--green-main)',
    fontFamily: 'var(--font-plex)',
    fontSize: '15px',
  },
  averageText: {
    color: 'var(--coffee-light)',
    fontFamily: 'var(--font-plex)',
    fontSize: '15px',
  },
  userRelationBox: {
    display: 'inline',
    fontWeight: '700',
    fontSize: '22px',
  },
  userRelation: {
    color: 'var(--orange-main)',
    display: 'inline',
    fontWeight: '700',
  },
  chartTitleNm: {
    fontFamily: 'var(--font-plex)',
    fontSize: '18px',
    fontWeight: '700',
    lineHeight: '1.4em',
    display: 'inline-block',
  },
  chartTitle: {
    fontFamily: 'var(--font-plex)',
    fontSize: '18px',
    fontWeight: '700',
    lineHeight: '1.4em',
    display: 'inline-block',
    marginBottom: '15px',
  },
  subline: {
    fontFamily: 'var(--font-plex)',
    fontSize: '15px',
    fontWeight: '4700',
    lineHeight: '1.4em',
    marginBottom: '30px',
    display: 'inline-block',
    color: 'var(--gray-3)',
  },
  boxText: {
    // color: 'var(--coffe-color)',
    fontSize: 22,
    lineHeight: '1.5em',
  },
  boxTextBold: {
    color: 'var(--coffe-color)',
    fontWeight: 700,
    fontSize: 22,
  },
  annotationUser: {
    fontFamily: 'var(--font-plex)',
    fontSize: '15px',
    fontWeight: '400',
    letterSpacing: '0.2px',
  },
  annotationUserBold: {
    fontFamily: 'var(--font-plex)',
    fontSize: '18px',
    fontWeight: '700',
    letterSpacing: '0.2px',
  },
  method: {
    fontFamily: 'var(--font-plex)',
    fontSize: '15px',
    fontWeight: '400',
    letterSpacing: '0.2px',
  },
}
